export default __webpack_public_path__ + "static/media/Group 27229.5ee6725b.svg";